import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SecondaryButton } from "@/components/ui-kit";

const labels = { admin: "Administrador", operator: "Operador", technician: "Técnico" };

export const UserRoleHistory = ({ user, onClose }) => (
  <Dialog open={!!user} onOpenChange={(open) => !open && onClose()}>
    <DialogContent data-testid="user-role-history-modal" className="bg-white text-neutral-900 w-[calc(100%_-_2rem)] max-w-xl max-h-[85vh] overflow-y-auto"
      overlayProps={{ "data-testid": "user-role-history-overlay", className: "bg-black/70", style: { animation: "none", opacity: 1 } }}>
      <DialogTitle data-testid="user-role-history-title">Cambios de rol · {user?.name}</DialogTitle>
      <DialogDescription>Últimos cambios registrados por administración.</DialogDescription>
      {!user?.role_history?.length ? <p data-testid="user-role-history-empty" className="py-6 text-sm text-neutral-500">Sin cambios registrados desde la incorporación del historial.</p> :
        <ol className="divide-y divide-neutral-200">{[...user.role_history].reverse().map((entry) => (
          <li key={entry.id} data-testid={`user-role-history-entry-${entry.id}`} className="py-4 space-y-2 text-sm break-words">
            <p data-testid={`user-role-history-transition-${entry.id}`} className="font-semibold">{labels[entry.from_role] || entry.from_role || "Sin rol"} → {labels[entry.to_role] || entry.to_role}</p>
            <p data-testid={`user-role-history-actor-${entry.id}`}>{entry.actor_name || entry.actor_email}</p>
            <time data-testid={`user-role-history-date-${entry.id}`} className="text-xs text-neutral-500">{new Date(entry.changed_at).toLocaleString("es-CL")}</time>
          </li>
        ))}</ol>}
      <SecondaryButton data-testid="user-role-history-close" onClick={onClose}>Cerrar</SecondaryButton>
    </DialogContent>
  </Dialog>
);